import React, { FC } from 'react'
import styles from './EmailCap.module.scss'
import { Currency } from 'prices/types'
import { Button as BasicButton } from 'components/basic/Button'
import { Button } from 'components/WebEv/Buttons'

interface Props {
	handleEmailChange: (email: React.ChangeEvent<HTMLInputElement>) => void
	emailHandleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
	currency: Currency
	closeModal: () => void
	subtitle: string
	buttonText: string
	title: string
	subheader: string
	dismissText: string
}

const EmailCap: FC<Props> = (props) => (
	<div className={styles.email_capture_wrapper}>
		{props.title ? <p className={styles.supertitle}>{props.title}</p> : null}
		<h3>{props.subheader}</h3>
		<p
			className={styles.subtitle}
			dangerouslySetInnerHTML={{ __html: props.subtitle }}
		/>
		<form
			className={styles.email_form}
			onSubmit={props.emailHandleSubmit}
		>
			<input
				required
				type="email"
				placeholder="Email *"
				onChange={props.handleEmailChange}
				aria-label="Your email address input"
				autoFocus
			/>
			<Button.Primary
				id={'email-submit-button'}
				className={styles.submitbutton}
				type="submit"
			>
				{props.buttonText}
			</Button.Primary>
		</form>
		<BasicButton
			content={props.dismissText}
			unstyled
			className={styles.button}
			onClick={props.closeModal}
		/>
		<div className={styles.disclaimer}>
			By continuing, you accept our privacy policy. Your personal data will be processed so that we can contact you about our products and send you surveys via e-mail. Read our Privacy Policy for more
			information.
		</div>
	</div>
)

export default EmailCap
